/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
import {
    API_DOMAIN,
    API_DOMAIN_LOCAL,
    API_ENDPOINT_BASE_DOKAN,
    API_ENDPOINT_BASE_WC,
} from '../ApiEnv';

// Product Api

export const withdrawAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/withdraw`;
export const withdrawBalanceAPI = `${withdrawAPI}/balance`;
